import { render, staticRenderFns } from "./compare-account.vue?vue&type=template&id=5da94ea4&scoped=true&"
import script from "./compare-account.vue?vue&type=script&lang=js&"
export * from "./compare-account.vue?vue&type=script&lang=js&"
import style0 from "./compare-account.vue?vue&type=style&index=0&id=5da94ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da94ea4",
  null
  
)

export default component.exports